(function(){
  var PORTAL="https://standardwear3.myshopify.com/apps/returns?order=%232577&zip=43201";
  var ACCOUNT="https://standardwear3.myshopify.com/pages/account?order=%232577&zip=43201";
  var BRAND="Express";
  function openModal(url,label){
    var m=document.createElement('div');m.className='loop-clone-modal';
    var inner=document.createElement('div');inner.className='loop-clone-modal-inner';
    var bar=document.createElement('div');bar.className='loop-clone-modal-bar';
    var span=document.createElement('span');span.textContent=(label||'Loop')+' — demo flow';
    var close=document.createElement('button');close.textContent='Close ✕';
    bar.appendChild(span);bar.appendChild(close);
    var fr=document.createElement('iframe');fr.src=url;
    inner.appendChild(bar);inner.appendChild(fr);m.appendChild(inner);document.body.appendChild(m);
    function c(){try{document.body.removeChild(m);}catch(e){}}
    close.addEventListener('click',c);
    m.addEventListener('click',function(e){if(e.target===m)c();});
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-loop-open]');
    if(!t)return;
    e.preventDefault();
    var kind=t.getAttribute('data-loop-open');
    openModal(kind==='account'?ACCOUNT:PORTAL, kind==='account'?'Returns':'Checkout+');
  });
})();